import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchWorkoutTypes = createAsyncThunk(
  'fitness/fetchWorkoutTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/techniques/workout-types/');
      console.log('Workout types response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching workout types:', error);
      return rejectWithValue(error.response?.data || 'Error fetching workout types');
    }
  }
);

export const addWorkoutType = createAsyncThunk(
  'fitness/addWorkoutType',
  async (workoutType) => {
    const response = await api.post('/techniques/workout-types/', workoutType);
    return response.data;
  }
);

export const fetchWorkouts = createAsyncThunk(
  'fitness/fetchWorkouts',
  async () => {
    const response = await api.get('/techniques/workouts/');
    return response.data;
  }
);

export const addWorkout = createAsyncThunk(
  'fitness/addWorkout',
  async (workout, { rejectWithValue }) => {
    try {
      console.log('Adding workout:', workout); // Debug log
      const response = await api.post('/techniques/workouts/', {
        date: workout.date,
        workout_type_id: workout.workout_type_id
      });
      console.log('Add workout response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      console.error('Error adding workout:', error);
      return rejectWithValue(error.response?.data || 'Error adding workout');
    }
  }
);

export const deleteWorkout = createAsyncThunk(
  'fitness/deleteWorkout',
  async (workoutId, { rejectWithValue }) => {
    try {
      console.log('Deleting workout:', workoutId); // Debug log
      await api.delete(`/techniques/workouts/${workoutId}/`);
      return workoutId;
    } catch (error) {
      console.error('Error deleting workout:', error);
      return rejectWithValue(error.response?.data || 'Error deleting workout');
    }
  }
);

export const deleteWorkoutType = createAsyncThunk(
  'fitness/deleteWorkoutType',
  async (typeId, { rejectWithValue }) => {
    try {
      await api.delete(`/techniques/workout-types/${typeId}/`);
      return typeId;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error deleting workout type');
    }
  }
);

const fitnessSlice = createSlice({
  name: 'fitness',
  initialState: {
    workoutTypes: [],
    workouts: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWorkoutTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkoutTypes.fulfilled, (state, action) => {
        state.workoutTypes = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchWorkoutTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchWorkouts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWorkouts.fulfilled, (state, action) => {
        state.workouts = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchWorkouts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addWorkout.fulfilled, (state, action) => {
        state.workouts.push(action.payload);
      })
      .addCase(deleteWorkout.fulfilled, (state, action) => {
        state.workouts = state.workouts.filter(w => w.id !== action.payload);
      })
      .addCase(addWorkoutType.fulfilled, (state, action) => {
        state.workoutTypes.push(action.payload);
      })
      .addCase(deleteWorkoutType.fulfilled, (state, action) => {
        state.workoutTypes = state.workoutTypes.filter(t => t.id !== action.payload);
      });
  },
});

export default fitnessSlice.reducer; 